module.exports = __webpack_public_path__ + "img/img25.1d3ee035.png";